// extracted by mini-css-extract-plugin
export var chevronIcon = "_d6-2";
export var teamName = "_d6-1";
export var teamSwitcherButton = "_d6-0";